import { collectionPointResource, CollectionPointResource } from '@witkac/kartamiejska-resources';
import { CollectionPoint } from '@witkac/kartamiejska-shared';

import { EntityModule } from './entity.module';

export class CollectionPointModule extends EntityModule<CollectionPoint, CollectionPointResource> {
  constructor() {
    super(collectionPointResource);
  }
}

export default new CollectionPointModule();
